const lines = {
    "main": {rows: [1, 1, 1, 1, 1, 1], costs : 1.0, mandatory : true} ,
    "top": {rows: [0, 0, 0, 0, 0, 0], costs : 1.0} ,
    "bottom": {rows: [2, 2, 2, 2, 2, 2], costs : 1.0} ,
    "diag1": {rows: [0, 0, 1, 1, 2, 2], costs : 2.0} ,
    "diag2": {rows: [2, 2, 1, 1, 0, 0], costs : 2.0} ,
    "cust1": {rows: [1, 0, 1, 2, 1, 1], costs : 3.0} ,
  }
  
const colors2 = {
  jackpots : {
    country :  'rgba(255,20,20,1)',
    casino :  'rgba(20,255,20,1)',
    machine :  'rgba(20,520,255,1)',
  }
}

const colors = {
  jackpots : {
    country :  'rgba(255,20,20,0.5)',
    casino :  'rgba(20,255,20,0.5)',
    machine :  'rgba(20,520,255,0.5)',
  }
}
const rows = 3;

export default {lines, colors, colors2, rows};